import { createAsyncThunk } from '@reduxjs/toolkit';
import { TryoutService } from 'Services/axios/Tryout.Service';
import { toast } from 'react-toastify';
import { handleApiError } from 'Features/Common/ErrorHandler';

export const fetchTryout = createAsyncThunk(
  'Tryout/fetchTryout',
  async (filters) => {
    try {
      const response = await TryoutService.getAll(filters);
      return response.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const orderTryoutQuestion = createAsyncThunk(
  'Tryout/orderTryoutQuestion',
  async (data) => {
    try {
      await TryoutService.setOrder(data.id, data.question_id);
      return true;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const submitTryout = createAsyncThunk(
  'addTryout/submitTryout',
  async (data) => {
    try {
      const formData = new FormData();
      formData.append('title', data.title);
      formData.append('description', data.description);
      formData.append('time', data.time);
      formData.append('start_at', data.start_at);
      formData.append('end_at', data.end_at);
      formData.append('quotas', data.quotas);
      formData.append('is_quiz', data.is_quiz);
      formData.append('is_live', data.is_live);
      formData.append('is_report_show', data.is_report_show);
      formData.append('is_toefl', data.is_toefl);
      if (data.is_toefl == "1") {
        data.toefl_setup.forEach((setup, index) => {
          formData.append(`toefl_setup[${index}][name]`, setup.name);
          formData.append(`toefl_setup[${index}][instructions]`, setup.instructions);
          formData.append(`toefl_setup[${index}][total_questions]`, setup.total_questions);
          formData.append(`toefl_setup[${index}][duration]`, setup.duration);
          formData.append(`toefl_setup[${index}][break]`, setup.break);
        });
      }
      formData.append('instruction', data.instruction);
      formData.append('ads_video', data.ads_video);
      formData.append('tutorial_video', data.tutorial_video);
      if (data.category && data.category.id) {
        formData.append('category_id', data.category.id);
      } else {
        formData.append('category_id', data.category);
      }
      data.banner && formData.append('banner', data.banner);
      formData.append('locked_type', data.locked_type);
      if (data.locked_type !== 'none') {
        formData.append('locked_until_at', data.locked_until_at);
        formData.append('locked_message', data.locked_message);
      }
      let response;
      if (data.isUpdate) {
        response = await TryoutService.update(data.id, formData);
      } else {
        response = await TryoutService.create(formData);
      }
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      data.successCallback && data.successCallback();
      return response.data.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const deleteTryout = createAsyncThunk(
  'deleteTryout/deleteTryout',
  async (id) => {
    try {
      const response = await TryoutService.delete(id);
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const attachTryout = createAsyncThunk(
  'attachTryout/attachTryout',
  async (attachment, { rejectWithValue }) => {
    try {
      await TryoutService.attach(attachment.id, attachment);
      return true;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const detachTryout = createAsyncThunk(
  'detachTryout/detachTryout',
  async (detachment, { rejectWithValue }) => {
    try {
      await TryoutService.detach(detachment.id, detachment);
      return true;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const replicateTryout = createAsyncThunk(
  'Tryout/replicateTryout',
  async ({ id, category_id }) => {
    try {
      const response = await TryoutService.replicate(id, category_id);
      return response;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const getSource = createAsyncThunk(
  'Tryout/getSource',
  async (params) => {
    try {
      const response = await TryoutService.getSource(params);
      return response.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);

export const exportRanking = createAsyncThunk(
  'Tryout/exportRanking',
  async ({ id, params, handleReset }) => {
    try {
      const response = await TryoutService.exportRanking(id, params);
      const fileLink = response.data.file;
      window.open(fileLink, '_blank');
      handleReset && handleReset();
      return response.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);